@if (cm.isActive() && rect()) {
  <div class="cm-root" [class.mobile]="isMobile()">
    <svg
      class="cm-backdrop"
      [attr.viewBox]="'0 0 ' + viewport().w + ' ' + viewport().h"
      preserveAspectRatio="none"
    >
      <path [attr.d]="maskPath()" fill-rule="evenodd" />
    </svg>

    <div class="cm-ring" [ngStyle]="ringStyle()"></div>

    <div
      class="cm-tooltip"
      [class]="'place-' + (tooltipPos()?.placement || 'bottom')"
      [class.mobile]="isMobile()"
      [style.left.px]="tooltipPos()?.left"
      [style.top.px]="tooltipPos()?.top"
      [style.--cm-arrow-offset.px]="tooltipPos()?.arrow"
    >
      <button class="cm-close" (click)="cm.skip()" title="Dismiss" aria-label="Dismiss tour">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      @if (step()?.title) {
        <div class="cm-title">{{ step()!.title }}</div>
      }
      <div class="cm-text">{{ step()?.text }}</div>

      <div class="cm-footer">
        <div class="cm-progress">
          @for (dot of dots(); track $index) {
            <span class="cm-dot" [class.active]="$index === cm.currentIndex()"></span>
          }
        </div>
        <div class="cm-actions">
          @if (!cm.isFirstStep()) {
            <button class="cm-btn cm-btn-ghost" (click)="cm.previous()">Back</button>
          }
          <button class="cm-btn cm-btn-primary" (click)="cm.next()">
            {{ cm.isLastStep() ? 'Got it' : 'Next' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
